<template>
	<div class="period-picker">
		<div class="period-input">
			<select v-model="selectedMonth" @change="updatePeriod">
				<option value="">Mois</option>
				<option
					v-for="(month, index) in months"
					:key="index"
					:value="padZero(index + 1)"
				>
					{{ month }}
				</option>
			</select>
			<span class="separator">/</span>
			<select v-model="selectedYear" @change="updatePeriod">
				<option value="">Année</option>
				<option v-for="year in years" :key="year" :value="year">
					{{ year }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
export default {
	name: "PeriodPicker",
	props: {
		value: {
			type: String,
			default: null,
		},
		startYear: {
			type: Number,
			default: 2000,
		},
		endYear: {
			type: Number,
			default: () => new Date().getFullYear() + 5,
		},
	},
	data() {
		return {
			months: [
				"Janvier",
				"Février",
				"Mars",
				"Avril",
				"Mai",
				"Juin",
				"Juillet",
				"Août",
				"Septembre",
				"Octobre",
				"Novembre",
				"Décembre",
			],
			selectedMonth: null,
			selectedYear: null,
		};
	},
	computed: {
		years() {
			const years = [];
			for (let i = this.startYear; i <= this.endYear; i++) {
				years.push(i);
			}
			return years;
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newValue) {
				if (newValue) {
					const [month, year] = newValue.split("/");
					this.selectedMonth = month;
					this.selectedYear = parseInt(year);
				} else {
					// If value is null or empty, clear the selections
					this.selectedMonth = null;
					this.selectedYear = null;
				}
			},
		},
	},
	methods: {
		updatePeriod() {
			if (this.selectedMonth && this.selectedYear) {
				this.$emit("input", `${this.selectedMonth}/${this.selectedYear}`);
			} else {
				// If either month or year is null/empty, emit null to clear the filter
				this.$emit("input", null);
			}
		},
		padZero(num) {
			return num < 10 ? `0${num}` : `${num}`;
		},
	},
};
</script>

<style scoped>
.period-picker {
	width: 100%;
}

.period-input {
	display: flex;
	align-items: center;
	width: 100%;
}

.period-input select {
	flex: 1;
	padding: 8px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
	appearance: auto;
	background-color: white;
}

.period-input select:focus {
	border-color: #1976d2;
	outline: none;
}

.separator {
	margin: 0 8px;
	font-weight: bold;
	color: #666;
}
</style>